import { apiHelper } from "app/common/services/apiHelper";
import categoryService from "app/common/services/categoryService";
import { i18nFilter } from "app/filters/i18nFilter";
import type { ComponentType } from "react";
import { useMemo } from "react";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { DefaultFetchService } from "app/services/fetchService";
import { allTrackers } from "app/services/track/track";
import type { ICategoryLeadersServices } from "../../CategoryLeaders.types";
import { CategoryLeadersContext } from "app/pages/industry-analysis/category-leaders/components/CategoryLeadersContext/CategoryLeadersContext";
import { proNavigator } from "single-spa/react-app/ProNavigator";

/**
 * Provides the category leaders context to the given component.
 * This is a high-order component, that injects the category leaders services
 * to the root of the target component.
 */
export const WithCategoryLeadersContextHOC = (Component: ComponentType) => {
    return function(props) {
        const services = useMemo<ICategoryLeadersServices>(() => {
            return {
                navigator: proNavigator,
                translate: i18nFilter(),
                categoryService: categoryService,
                customCategoryService: UserCustomCategoryService,
                apiHelper: apiHelper,
                fetchService: DefaultFetchService.getInstance(),
                tracker: allTrackers,
            };
        }, []);

        return (
            <CategoryLeadersContext.Provider value={{ services }}>
                <Component {...props} />
            </CategoryLeadersContext.Provider>
        );
    };
};
